/*
 * Healthier Choice explainer card — popup video controller + stage tracking
 * Defined ONCE and loaded from the top of main-collection-product-grid.liquid
 * (outside #ProductGridContainer) so it survives Dawn's filter re-render.
 * The <healthier-choice-modal> element instance lives inside the grid and
 * auto-upgrades every time the grid innerHTML is replaced by facets.js.
 *
 * Stage tracking records the deepest video stage reached as cart attributes:
 * `_hcl_video_stage` and `_hcl_video_at`. The flag rides along to the order.
 */
(function () {
  var STAGES = ['opened', 'played_3s', 'played_15s', 'played_50pct', 'completed'];
  var maxRank = -1;

  function rank(stage) {
    return STAGES.indexOf(stage);
  }

  function recordStage(stage) {
    var r = rank(stage);
    if (r < 0 || r <= maxRank) return;
    maxRank = r;

    try {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          attributes: {
            _hcl_video_stage: stage,
            _hcl_video_at: new Date().toISOString().slice(0, 10),
          },
        }),
      }).catch(function () {});
    } catch (e) {}
  }

  if (customElements.get('healthier-choice-modal')) return;

  customElements.define(
    'healthier-choice-modal',
    class HealthierChoiceModal extends HTMLElement {
      connectedCallback() {
        if (this._wired) return;
        this._wired = true;

        this.trigger = this.querySelector('[data-hc-open]');
        this.dialog = this.querySelector('[data-hc-dialog]');
        this.template = this.querySelector('template');
        this.videoMount = this.querySelector('[data-hc-video-mount]');
        this.dialogHome = document.createComment('healthier-choice-dialog-home');

        if (this.trigger) {
          this.trigger.addEventListener('click', () => this.open());
        }
        this.querySelectorAll('[data-hc-close]').forEach((el) =>
          el.addEventListener('click', () => this.close())
        );

        this._onKeydown = (e) => {
          if (e.key === 'Escape') this.close();
        };
      }

      _wireVideoStages(video) {
        if (!video || video._hcStaged) return;
        video._hcStaged = true;

        video.addEventListener('timeupdate', function () {
          var t = video.currentTime || 0;
          var d = video.duration || 0;

          if (t >= 3) recordStage('played_3s');
          if (t >= 15) recordStage('played_15s');
          if (d > 0 && t / d >= 0.5) recordStage('played_50pct');
        });

        video.addEventListener('ended', function () {
          recordStage('completed');
        });
      }

      disconnectedCallback() {
        const video = this.videoMount && this.videoMount.querySelector('video');
        if (video) {
          try {
            video.pause();
          } catch (e) {}
        }
        if (this.videoMount) this.videoMount.innerHTML = '';

        document.removeEventListener('keydown', this._onKeydown);
        document.body.classList.remove('hc-modal-open');

        if (this.dialog && this.dialog.parentNode !== this) {
          this.dialog.remove();
        }
      }

      open() {
        if (!this.dialog) return;

        // Lazy-mount the video only on first open (defers the MP4 download).
        if (this.template && this.videoMount && !this.videoMount.hasChildNodes()) {
          this.videoMount.appendChild(this.template.content.cloneNode(true));
        }

        // Move the fixed dialog to <body> so product-card/grid stacking contexts
        // cannot paint above the video overlay.
        if (this.dialog.parentNode !== document.body) {
          this.dialog.after(this.dialogHome);
          document.body.appendChild(this.dialog);
        }

        recordStage('opened');

        this.dialog.hidden = false;
        document.body.classList.add('hc-modal-open');
        document.addEventListener('keydown', this._onKeydown);

        const video = this.videoMount && this.videoMount.querySelector('video');
        if (video) {
          this._wireVideoStages(video);
          // user-initiated → sound allowed
          video.play().catch(() => {});
        }

        const closeBtn = this.dialog.querySelector('[data-hc-close]');
        if (closeBtn) closeBtn.focus();
      }

      close() {
        if (!this.dialog) return;

        const video = this.videoMount && this.videoMount.querySelector('video');
        if (video) {
          try {
            video.pause();
          } catch (e) {}
        }
        // Tear down the video so it stops buffering in the background.
        if (this.videoMount) this.videoMount.innerHTML = '';

        this.dialog.hidden = true;
        if (this.dialogHome.parentNode) {
          this.dialogHome.parentNode.insertBefore(this.dialog, this.dialogHome);
          this.dialogHome.remove();
        }
        document.body.classList.remove('hc-modal-open');
        document.removeEventListener('keydown', this._onKeydown);

        if (this.trigger) this.trigger.focus();
      }
    }
  );
})();
